import moment from 'moment';

export const getNormalizeDate = (currentDate: moment.MomentInput) => {
  const date = moment(currentDate);
  const normalizeDate = date.format("MMMM Do YYYY")

  return normalizeDate;
};